(function ($) {
  $.fn.companyStatement = function () {
    this.each((eleIndex, element) => {
      const $self = $(element);
      const imageCutWidth = 50;
      const imageContentSpace = 50;
      let screenWidth,
        containerWidth,
        widthAvailable,
        prevStatementContainer,
        imageMargin,
        statementMargin;
      const $statements = $self.find('.company-statement');

      function init() {
        // Calculate available space
        screenWidth = $('body').outerWidth();
        containerWidth = $self.width();
        widthAvailable = (screenWidth - containerWidth) / 2;
        // Check each statement
        $statements.each((index, statementContainer) => {
          // Check screen width
          if (screenWidth <= 2000) {
            imageMargin = '-' + (widthAvailable + imageCutWidth) + 'px';
            if ($(statementContainer).hasClass('flip-content')) {
              $(statementContainer)
                .find('.statement-image-container')
                .css('margin-left', imageMargin);
            } else {
              $(statementContainer)
                .find('.statement-image-container')
                .css('margin-right', imageMargin);
            }
          }
          if (screenWidth <= 768) {
            if ($(statementContainer).hasClass('flip-content')) {
              $(statementContainer)
                .find('.statement-image-container')
                .css('margin-left', '0');
            } else {
              $(statementContainer)
                .find('.statement-image-container')
                .css('margin-right', '0');
            }
          }
          // For top margin
          if (
            index !== 0 &&
            !(
              ($(prevStatementContainer).hasClass('flip-content') &&
                $(statementContainer).hasClass('flip-content')) ||
              (!$(prevStatementContainer).hasClass('flip-content') &&
                !$(statementContainer).hasClass('flip-content'))
            )
          ) {
            let availableHeight,
              firstAvailableHeight,
              secondAvailableHeight,
              prevContentBtm,
              prevImageBtm,
              currentContentTop,
              currentImageTop;
            prevContentBtm =
              $(prevStatementContainer).find('.statement-content').offset()
                .top +
              $(prevStatementContainer).find('.statement-content').height();
            prevImageBtm =
              $(prevStatementContainer)
                .find('.statement-image-container')
                .offset().top +
              $(prevStatementContainer)
                .find('.statement-image-container')
                .height();
            currentContentTop = $(statementContainer)
              .find('.statement-content')
              .offset().top;
            currentImageTop = $(statementContainer)
              .find('.statement-image-container')
              .offset().top;

            firstAvailableHeight = currentImageTop - prevContentBtm;
            secondAvailableHeight = currentContentTop - prevImageBtm;
            availableHeight =
              firstAvailableHeight < secondAvailableHeight
                ? firstAvailableHeight
                : secondAvailableHeight;

            // If having ability to change margin
            if (availableHeight > imageContentSpace) {
              statementMargin =
                '-' + (availableHeight - imageContentSpace) + 'px';
              $(statementContainer).css('margin-top', statementMargin);
              if (screenWidth <= 768) {
                $(statementContainer).css('margin-top', '35px');
              }
            }
          }

          prevStatementContainer = statementContainer;
        });
      }

      $(window).on('resize', () => {
        init();
      });

      init();
    });

    return this;
  };

  $(() => {
    $('.module.company-statements').companyStatement();
  });
})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/company-statement.js